//-------------------
//音声ファイル
var snd = [ ]; //配列

snd[0] = "https://cdn.shopify.com/s/files/1/0579/5466/4643/files/kawachibankan.mp3?v=1624324524";
snd[1] = "https://cdn.shopify.com/s/files/1/0579/5466/4643/files/kanpei.mp3?v=1624324524";
snd[2] = "https://cdn.shopify.com/s/files/1/0579/5466/4643/files/housemikan.mp3?v=1624324524";
snd[3] = "https://cdn.shopify.com/s/files/1/0579/5466/4643/files/hamadonna.mp3?v=1624324524";
snd[4] = "https://cdn.shopify.com/s/files/1/0579/5466/4643/files/debeso.mp3?v=1624324524";
snd[5] = "https://cdn.shopify.com/s/files/1/0579/5466/4643/files/buntan.mp3?v=1624324525";
snd[6] = "https://cdn.shopify.com/s/files/1/0579/5466/4643/files/bankanjuice.mp3?v=1624324524";
//-------------------

//複数の音声を鳴らす関数
function ring(num) {

	var player = document.getElementById("player");

	player.pause(); //再生中なら停止
	player.src = snd[num]; //ファイルを指定
	player.play(); //再生

}
